import { createSelector } from 'reselect';
import { get } from 'lodash';

import { SCOPE } from './types';
import { requestIntervalSelector } from '../data/selectors';

const selector = state => get(state, SCOPE);
export default selector;

export const configIntervalSelector = createSelector(
  selector,
  requestIntervalSelector,
  (store, requestInterval) => {
    const [requestStartTime, requestEndTime] = requestInterval;

    const configStartTime = get(store, ['startTime'], 0);
    const configEndTime = get(store, ['endTime'], 0);

    const startTime = configStartTime || requestStartTime;
    const endTime = configEndTime || requestEndTime;

    return {
      startTime,
      endTime,
      configStartTime,
      configEndTime,
    };
  },
);

export const configGranularitySelector = createSelector(selector, (store) => {
  const granularity = get(store, ['granularity'], 'm');
  return granularity;
});
